/*
 *
 * ClassesDetail reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE,
  LOAD_CLASS,
  LOAD_CLASS_SUCCESS,
  LOAD_CLASS_ERROR
} from './constants';

export const initialState = {
  firstRender: true,
  loading: false,
  error: false,
  itemData: false,
  id: false,
};

/* eslint-disable default-case, no-param-reassign */
const classesDetailReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE:
        return initialState;

      // Load 
      case LOAD_CLASS:
        draft.loading = true;
        draft.error = false;
        draft.id = action.id;
        break;

      case LOAD_CLASS_SUCCESS:
        draft.itemData = action.itemData;
        draft.loading = false;
        draft.firstRender = false;
        break;

      case LOAD_CLASS_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;
      
    }
  });

export default classesDetailReducer;
